// Copyright (c) 2023 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { MANUAL_TIME_ACTIVITY, } from "./index"
import { ActivityTypeOption } from "../activities"

export type StorageWriter = (value: ActivityTypeOption) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(MANUAL_TIME_ACTIVITY, JSON.stringify(value))
}

export const persistActivity = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setInputActivity.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.activityPersisted()),
        catchError(_ => of(Actions.activityPersistFailed())),
      )),
    )

export default persistActivity(persist)
